import { render, staticRenderFns } from "./BuyTicketProcedure.vue?vue&type=template&id=5a874874&scoped=true&"
import script from "./BuyTicketProcedure.vue?vue&type=script&lang=js&"
export * from "./BuyTicketProcedure.vue?vue&type=script&lang=js&"
import style0 from "./BuyTicketProcedure.vue?vue&type=style&index=0&id=5a874874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a874874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VImg,VRow})
